import {Link} from "react-router-dom";

export function LinkButton(props){
    const {link, text} = props
    return <Link to={link} className={'primaryButton'}> {text} </Link>
}